module.exports = __webpack_public_path__ + "static/img/exploit17.6b4412fd.png";